import { Button } from "antd";
import React from "react";

function FormAction({ save, cancel, submit, btnText, disable, loading }) {
  return (
    <div className="form-action page-actions-container">
      <Button loading={loading} type="primary" htmlType={submit ? submit : "button"} onClick={save} disabled={disable}>
        {btnText !== undefined ? btnText : loading ? "Please wait..." : "save"}
      </Button>
      <Button onClick={cancel}>Cancel</Button>
    </div>
  );
}

export default FormAction;
